import { render, staticRenderFns } from "./entity-company-details.vue?vue&type=template&id=c8ea99a6"
import script from "./entity-company-details.vue?vue&type=script&lang=js"
export * from "./entity-company-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports